export const normalizeEvidencePolicy = item => ({
  whenMissing: item?.whenMissing === "block" ? "block" : "warn",
  delivery: item?.delivery === "on_file" ? "on_file" : "attach",
});
export const summarizeEvidence = (items = []) => {
  const required = items.filter(item => item.required);
  const received = required.filter(item => item.received);
  const missing = required.filter(item => !item.received);
  const blockingMissing = missing.filter(item => normalizeEvidencePolicy(item).whenMissing === "block").length;
  return { required: required.length, received: received.length, verified: received.length, missing: missing.length, blockingMissing, warningMissing: missing.length - blockingMissing };
};
export const mergeEvidenceSummaries = summaries => summaries.reduce((total, item) => ({
  required: total.required + (item.required || 0), received: total.received + (item.received || 0), verified: total.verified + (item.verified || 0), missing: total.missing + (item.missing || 0),
  blockingMissing: total.blockingMissing + (item.blockingMissing || 0), warningMissing: total.warningMissing + (item.warningMissing || 0),
}), { required:0, received:0, verified:0, missing:0, blockingMissing:0, warningMissing:0 });
// Unknown pre-normalized summaries retain their previous conservative behavior.
export const missingBlockingCount = summary => Number(summary?.blockingMissing ?? summary?.missing ?? 0);
export const evidenceStatus = item => {
  if (item?.required && !item?.received) return normalizeEvidencePolicy(item).whenMissing === "block"
    ? { indicator:"error", label:"Missing — blocks sending" }
    : { indicator:"warning", label:"Missing — warning" };
  if (item?.received) return { indicator:"success", label:normalizeEvidencePolicy(item).delivery === "on_file" ? "On file" : "Received" };
  return { indicator:"info", label:"Optional" };
};
